import { render, staticRenderFns } from "./NewContentAvailableToastr.vue?vue&type=template&id=5168aecc&scoped=true"
import script from "./NewContentAvailableToastr.vue?vue&type=script&lang=js"
export * from "./NewContentAvailableToastr.vue?vue&type=script&lang=js"
import style0 from "./NewContentAvailableToastr.vue?vue&type=style&index=0&id=5168aecc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5168aecc",
  null
  
)

export default component.exports